import * as React from "react";
import type { SVGProps } from "react";
const SvgHelp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.546 14.546a3.6 3.6 0 0 1-5.092 0m5.092 0a3.6 3.6 0 0 0 0-5.092m0 5.092 3.818 3.818m-8.91-3.818a3.6 3.6 0 0 1 0-5.092m0 5.092-3.818 3.818m3.818-8.91a3.6 3.6 0 0 1 5.092 0m-5.092 0L5.636 5.636m8.91 3.818 3.818-3.818m.424 13.152a9.6 9.6 0 0 1-13.576 0 9.6 9.6 0 0 1 0-13.576 9.6 9.6 0 0 1 13.576 0 9.6 9.6 0 0 1 0 13.576"
    />
  </svg>
);
export default SvgHelp;
